module.exports = [{"type":"title","text":"2024-05-27"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual contract new:Subscribe to 24-hour price changes of all trading pairs"},{"type":"html","text":"Perpetual contract new:Subscribe K-Line Data of all trading pairs"},{"type":"html","text":"Perpetual contract new:Subscribe Market Depth Data of all trading pairs"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-05-27.json
// module id = ED08
// module chunks = 3